import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserFriends, faGift, faRotate, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { faHeart as farFaHeart, faBell as farFaBell } from '@fortawesome/free-regular-svg-icons';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';

import 'Components/Wishlist/WishlistSellingPoints.scss';

import { toggleLoginModal } from 'Redux/ducks/modal';

const WishlistSelingPoints = ({
  authenticated,
  toggleLoginModal: propsToggleLoginModal,
  myFriends,
}) =>
  <div className="wishlist-selling-points">
    {!myFriends &&
      <React.Fragment>
        <h2 className="mb-3">
          <FormattedMessage id="wislist.title.empty" defaultMessage="Your Wishlist is currently empty" />
        </h2>
        {!authenticated &&
          <Button color="link" className="login-link" onClick={propsToggleLoginModal}>
            <FormattedMessage id="wishlist.logintostart" defaultMessage="Login to see your saved Wishlist" />
          </Button>
        }
        <p className="wishlist-intro">
          <FormattedMessage
            id="wishlist.body"
            defaultMessage="Your Wishlist is a great way to keep track of the games you want. Create your own Wishlist now by clicking on the {quote}Add to Wishlist{quote} icon {heartIcon} from the product page, or when you hover over a product on the front page (desktop only)."
            values={{ heartIcon: <FontAwesomeIcon icon={farFaHeart} />, quote: '"' }}
          />
        </p>

        <div className="wishlist-selling-container">
          <div className="wishlist-sell-box adding">
            <div className="icon-container">
              <FontAwesomeIcon icon={farFaHeart} />
            </div>
            <div className="message-container">
              <div className="message-title">
                <FormattedMessage id="wishlist.selling-point.adding.title" defaultMessage="Add to your wishlist" />
              </div>
              <div className="message-subtitle">
                <FormattedMessage id="wishlist.selling-point.adding.subtitle" defaultMessage="Discover new games and bundles and keep track of all your favourites" />
              </div>
            </div>
          </div>

          <div className="wishlist-sell-box syncing">
            <div className="icon-container">
              <FontAwesomeIcon icon={faRotate} />
            </div>
            <div className="message-container">
              <div className="message-title">
                <FormattedMessage id="wishlist.selling-point.syncing.title" defaultMessage="Steam wishlist sync" />
              </div>
              <div className="message-subtitle">
                <FormattedMessage id="wishlist.selling-point.syncing.subtitle" defaultMessage="Import your Wishlist from Steam in your account area" />
              </div>
            </div>
          </div>

          <div className="wishlist-sell-box notification">
            <div className="icon-container">
              <FontAwesomeIcon icon={farFaBell} />
            </div>
            <div className="message-container">
              <div className="message-title">
                <FormattedMessage id="wishlist.selling-point.notification.title" defaultMessage="Never miss a deal" />
              </div>
              <div className="message-subtitle">
                <FormattedMessage id="wishlist.selling-point.notification.subtitle" defaultMessage="Get email alerts when your Wishlist items go on sale or into a bundle" />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    }

    {myFriends &&
      <React.Fragment>
        <h2 className="mb-3">
          <FormattedMessage id="wislist.title.selectfriend" defaultMessage="Select a friend to browse their wishlist" />
        </h2>

        {!authenticated &&
          <Button color="link" className="login-link" onClick={propsToggleLoginModal}>
            <FormattedMessage id="wishlist.logintoseelists" defaultMessage="Login to get started or see your friends' Wishlists" />
          </Button>
        }
        <p className="wishlist-intro">
          <FormattedMessage
            id="wishlist.myfriends.body"
            defaultMessage="'My Friends' is a great place to keep track of your friends' wishlists. From here you can see their profiles, explore content they’re interested in and send gifts from their wishlist directly to them. Ask a friend to share their wishlist link with you."
          />
        </p>

        <div className="wishlist-selling-container">
          <div className="wishlist-sell-box syncing">
            <div className="icon-container">
              <FontAwesomeIcon icon={faGift} />
            </div>
            <div className="message-container">
              <div className="message-title">
                <FormattedMessage id="wishlist.selling-point.sendagift" defaultMessage="Send A Gift" />
              </div>
              <div className="message-subtitle">
                <FormattedMessage id="wishlist.selling-point.sendagift.subtitle" defaultMessage="Click on this icon to send a gift directly to a friend" />
              </div>
            </div>
          </div>

          <div className="wishlist-sell-box notification">
            <div className="icon-container">
              <FontAwesomeIcon icon={faUserFriends} />
            </div>
            <div className="message-container">
              <div className="message-title">
                <FormattedMessage id="wishlist.addfriends" defaultMessage="Add Friends" />
              </div>
              <div className="message-subtitle">
                <FormattedMessage id="wishlist.selling-point.addfriend.subtitle" defaultMessage="Save your friends' wishlists and revist them at any time" />
              </div>
            </div>
          </div>

          <div className="wishlist-sell-box adding">
            <div className="icon-container">
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </div>
            <div className="message-container">
              <div className="message-title">
                <FormattedMessage id="wishlist.selling-point.explore" defaultMessage="Explore Content" />
              </div>
              <div className="message-subtitle">
                <FormattedMessage id="wishlist.selling-point.explore.subtitle" defaultMessage="Discover new games and bundles from your friends' wishlists" />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    }
  </div>;

WishlistSelingPoints.propTypes = {
  authenticated: PropTypes.bool,
  toggleLoginModal: PropTypes.func.isRequired,
  myFriends: PropTypes.bool,
};

WishlistSelingPoints.defaultProps = {
  authenticated: false,
  myFriends: false,
};


const mapStateToProps = ({
  auth: { authenticated },
}) => ({
  authenticated,
});

const mapDispatchToProps = {
  toggleLoginModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(WishlistSelingPoints);
